//** Lead Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
// import themeConfig from '../../../configs/themeConfig';
import { setLoading } from '../../../../@core/components/skelton/store';

export const getWebForm = createAsyncThunk('webFormSlice/getWebForm', async (_, { dispatch }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/webform', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        dispatch(setLoading(false));
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getWebFormById = createAsyncThunk('webFormSlice/getWebFormById', async (data) => {
    try {
        // showLoader(true);
        let response = await axios.get('/webform/' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        // showLoader(false);
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getDynamicWebFormById = createAsyncThunk('webFormSlice/getDynamicWebFormById', async (data, { rejectWithValue }) => {
    try {
        // showLoader(true);
        let response = await axios.get('/webform/web-form/' + data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        // showLoader(false);
        // console.log('err', err);
        // toast.error(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const getMyOperator = createAsyncThunk('webFormSlice/get-call-configuration', async () => {
    try {
        let response = await axios.get('/get-call-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createWebForm = createAsyncThunk('webFormSlice/createWebForm', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/webform', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'WebForm added successfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createMyOperator = createAsyncThunk('oneOneZaSliMyOperator', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/myoperator-configurations', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'MyOperator  added successfully.');
        dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateWebForm = createAsyncThunk('webFormSlice/updateWebForm', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/webform/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'WebForm updated successfully.');
        await dispatch(getWebForm());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateWebFormStatus = createAsyncThunk('webFormSlice/updateWebFormStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/webform/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'WebForm updated successfully.');
        await dispatch(getWebForm());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateMyOperator = createAsyncThunk('webFormSlice/updateMyOperator', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/call-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'MyOperator updated successfully.');
        await dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateMyOperatorStatus = createAsyncThunk('webFormSlice/updateMyOperatorStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/call-configuration/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'My Operator Status Changed successfully.');
        await dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err during update My Operator status ', error?.response?.data);
        return Promise.reject(error?.response?.data);
    }
});

export const deleteWebForm = createAsyncThunk('webFormSlice/deleteWebForm', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/webform/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'WebForm deleted successfully.');
        await dispatch(getWebForm());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteMyOperator = createAsyncThunk('webFormSlice/deleteMyOperator', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/call-configuration/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'MyOperator deleted successfully.');
        await dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const webFormSlice = createSlice({
    name: 'webFormSlice',
    initialState: {
        data: [],
        selectedWebForm: {},
        myOperator: [],
        dynamicWebForm: []
    },
    reducers: {
        removeSelectedWebForm: (state, action) => {
            state.selectedWebForm = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getWebForm.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getWebFormById.fulfilled, (state, action) => {
            state.selectedWebForm = action.payload;
            return;
        });
        builder.addCase(getMyOperator.fulfilled, (state, action) => {
            state.myOperator = action.payload;
            return;
        });
        builder.addCase(getDynamicWebFormById.fulfilled, (state, action) => {
            state.dynamicWebForm = action.payload;
            return;
        });
    }
});
export const { removeSelectedWebForm } = webFormSlice.actions;
export default webFormSlice.reducer;
